import { convertKeysToPascalCase } from 'helpers/convertKeysToPascalCase'
import { APPLICATION_KEY_OVERRIDES } from 'helpers/application-key-overrides'
import { PersonRelationshipEnum } from '@surecompanies/contracts'

function findEmployeeStateProvince(persons = []) {
  const employee = persons.find(
    (person) => person?.Relationship === PersonRelationshipEnum.EMPLOYEE
  )
  return employee?.StateProvince ?? employee?.stateProvince ?? null
}

/**
 * Normalizes EPS application-get camelCase payloads to the PascalCase shape
 * expected by Application Manager detail views.
 */
export function remapApplicationResponse(raw) {
  if (!raw) return raw

  const remapped = convertKeysToPascalCase(raw, APPLICATION_KEY_OVERRIDES)

  return {
    ...remapped,
    StateProvince:
      remapped.StateProvince ?? findEmployeeStateProvince(remapped.Persons),
  }
}
